import { useEditorStore } from "./store/editorStore";

export function ValidationPanel({ onClose }: { onClose: () => void }) {
    const validation = useEditorStore((s) => s.validation);
    const select = useEditorStore((s) => s.select);

    const jumpTo = (nodeId: string | null) => {
        if (!nodeId) return;
        select(nodeId);
        document
            .querySelector(`[data-node-id="${nodeId}"]`)
            ?.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    return (
        <div className="validation-panel" role="region" aria-label="Validation results" data-testid="validation-panel">
            <div className="validation-head">
                <strong>Checks</strong>
                <span className="muted">
                    {validation.length === 0 ? "No problems found" : `${validation.length} finding(s)`}
                </span>
                <button type="button" className="tb-btn" onClick={onClose} aria-label="Close checks">
                    ✕
                </button>
            </div>
            <ul className="validation-list">
                {validation.map((w, i) => (
                    <li key={i} className={`validation-item ${w.severity}`}>
                        <button
                            type="button"
                            className="validation-link"
                            onClick={() => jumpTo(w.nodeId)}
                            disabled={!w.nodeId}
                        >
                            <span className={`sev-dot ${w.severity}`} aria-hidden />
                            <span className="validation-msg">{w.message}</span>
                            {w.nodeId && <span className="validation-jump">show</span>}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
